import {
  DropletsIcon,
  HandIcon,
  LayoutGridIcon,
  SquareDashedIcon,
  FootprintsIcon,
  WrenchIcon,
} from 'lucide-react';
import type { PoolProblem } from '../types/content';
import { images } from './business';

export const problems: PoolProblem[] = [
  {
    id: 'stained',
    title: 'Stained or Worn Surface',
    description: "Dark spots, discoloration, or patches that won't brush away.",
    image: images.stained,
    imageAlt: 'Close-up of a stained, blotchy pool surface',
    icon: DropletsIcon,
  },
  {
    id: 'plaster',
    title: 'Aging Plaster',
    description: 'Rough, etched, or chalky plaster that is hard on feet and swimsuits.',
    image: images.before,
    imageAlt: 'Aging pool with gray, worn plaster',
    icon: HandIcon,
  },
  {
    id: 'tile',
    title: 'Outdated Tile',
    description: 'Faded, cracked, or dated waterline tile that ages the whole pool.',
    image: images.coping,
    imageAlt: 'Dated waterline tile below worn coping',
    icon: LayoutGridIcon,
  },
  {
    id: 'coping',
    title: 'Damaged Coping',
    description: 'Cracked, loose, or chipped stones and edges around the pool.',
    image: images.coping,
    imageAlt: 'Cracked and chipped concrete pool coping',
    icon: SquareDashedIcon,
  },
  {
    id: 'deck',
    title: 'Old Pool Deck',
    description: 'Faded, cracked, or stained decking that is uncomfortable to walk on.',
    image: images.before,
    imageAlt: 'Faded, worn pool deck around an older pool',
    icon: FootprintsIcon,
  },
  {
    id: 'equipment',
    title: 'Equipment Problems',
    description: 'Noisy pumps, leaks, low pressure, or equipment that keeps breaking down.',
    image: images.equipment,
    imageAlt: 'Residential pool equipment pad',
    icon: WrenchIcon,
  },
];
